/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import ScrollFadeIn from './../scroll-fade/./scroll-fade';
// @ts-ignore
import {MobileBreakpoint} from './../../themes/kent/utilities/constants';

interface IProps {
  image?: string;
  mobileImage?:string;
  height?:string;
}

class FullWidthImage extends React.Component<IProps> {

  public render(): JSX.Element {
    let heightClass:string = "";
    if(this.props.height){
      heightClass = this.props.height;
    }
    const image = (window.outerWidth < MobileBreakpoint && this.props.mobileImage) ? this.props.mobileImage : this.props.image;
    return (
      <ScrollFadeIn>
        {image && <img className={"full-width "+heightClass} src={image} />}
      </ScrollFadeIn>
    );
  }
}

export default FullWidthImage;
